import React, { useState } from "react";
import { HiX, HiPencil, HiTrash, HiOutlineUserGroup } from "react-icons/hi";
import ModalEditarUsuario from "./ModalEditarUsuario";
import ModalConfirmacion from "./ModalConfirmacion";
import "../styles.css";

export default function ListaUsuarios({ visible, onClose, usuarios, onEliminar, onActualizar }) {
  const [usuarioEditar, setUsuarioEditar] = useState(null);
  const [usuarioEliminar, setUsuarioEliminar] = useState(null);

  if (!visible) return null;

  const handleEditarClick = (usuario) => {
    setUsuarioEditar(usuario);
  };

  const handleCerrarModalEditar = () => {
    setUsuarioEditar(null);
  };

  const handleGuardarCambios = async (username, password, rol) => {
    if (onActualizar) {
      await onActualizar(username, password, rol);
    }
    handleCerrarModalEditar();
  };

  const handleEliminarClick = (usuario) => {
    setUsuarioEliminar(usuario);
  };

  const handleConfirmarEliminar = async () => {
    if (usuarioEliminar && onEliminar) {
      await onEliminar(usuarioEliminar.username);
    }
    setUsuarioEliminar(null);
  };

  return (
    <div className="modal-overlay">
      <div className="modal animate-fadeIn" style={{ maxWidth: '800px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <HiOutlineUserGroup size={24} style={{ color: 'var(--accent-primary)' }} />
            <h2 style={{ margin: 0 }}>Gestión de Usuarios</h2>
          </div>
          <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <HiX size={24} />
          </button>
        </div>

        <div className="usuarios-table-container" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <table className="user-management-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 8px' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: 'var(--text-secondary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                <th style={{ padding: '0 16px 8px' }}>Usuario</th>
                <th style={{ padding: '0 16px 8px' }}>Rol</th>
                <th style={{ padding: '0 16px 8px' }}>Creado el</th>
                <th style={{ padding: '0 16px 8px', textAlign: 'right' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u) => (
                <tr key={u.id || u.username} className="user-row" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--glass-border)', transition: 'var(--transition-fast)' }}>
                  <td style={{ padding: '16px', borderRadius: 'var(--radius-md) 0 0 var(--radius-md)', fontWeight: 600 }}>{u.username}</td>
                  <td style={{ padding: '16px' }}>
                    <span className={`badge-role ${u.rol}`} style={{
                      padding: '4px 10px',
                      borderRadius: '99px',
                      fontSize: '0.7rem',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      background: u.rol === 'admin' ? 'rgba(56, 189, 248, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                      color: u.rol === 'admin' ? 'var(--accent-primary)' : 'var(--text-secondary)'
                    }}>
                      {u.rol}
                    </span>
                  </td>
                  <td style={{ padding: '16px', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>{u.fecha_creacion || "—"}</td>
                  <td style={{ padding: '16px', borderRadius: '0 var(--radius-md) var(--radius-md) 0', textAlign: 'right' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                      <button
                        className="btn-icon-circular"
                        onClick={() => handleEditarClick(u)}
                        title="Editar usuario"
                        style={{ border: 'none', background: 'rgba(255,255,255,0.05)', color: 'var(--text-primary)', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <HiPencil size={16} />
                      </button>
                      <button
                        className="btn-icon-circular danger"
                        onClick={() => handleEliminarClick(u)}
                        title="Eliminar usuario"
                        style={{ border: 'none', background: 'rgba(239, 68, 68, 0.1)', color: 'var(--accent-danger)', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <HiTrash size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="modal-footer" style={{ marginTop: '32px', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn-gestion" onClick={onClose}>
            Cerrar
          </button>
        </div>

        {usuarioEditar && (
          <ModalEditarUsuario
            visible={true}
            usuario={usuarioEditar}
            onClose={handleCerrarModalEditar}
            onGuardar={handleGuardarCambios}
          />
        )}

        {usuarioEliminar && (
          <ModalConfirmacion
            visible={true}
            titulo="Eliminar Usuario"
            mensaje={`¿Estás seguro de que deseas eliminar permanentemente a "${usuarioEliminar.username}"?`}
            tipo="rojo"
            onConfirmar={handleConfirmarEliminar}
            onCancelar={() => setUsuarioEliminar(null)}
          />
        )}
      </div>
    </div>
  );
}
